<template>
  <div class="history-card">
    <div class="card card-info mr-3">
      <div class="card-bodyinf">
        <div class="d-flex-between">
          <p :class="'label font-12 mar-bot-4 ' + status_css">
            {{ status_fix }}
          </p>
        </div>
        <p class="mar-bot-2 f-15">Cicilan ke {{ cicilan_ke }}</p>
        <b class="f-16">Rp {{ formatRupiah(cicilan_tagihan) }}</b>
      </div>
      <div class="d-flex justify-content-between">
        <div class="countdown pt-1">
          <svg
            class="custom-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clip-path="url(#clip0_1520_19609)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                fill="#808080"
              />
            </g>
            <defs>
              <clipPath id="clip0_1520_19609">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="pad-5 f-14 f-c-midgrey">{{
            $moment(expired_at).format("DD MMMM YYYY")
          }}</span>
        </div>
        <button
          class="tombol btn btn-outline-primary"
          @click="handleButtonClick"
        >
          Bayar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "CardCicilan",
  data() {
    return {
      paramnya: this.idCicilan,
    };
  },
  props: {
    status: "",
    cicilan_ke: "",
    cicilan_tagihan: "",
    expired_at: "",
    idCicilan: "",
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      detailPesanan: "detailPesanan",
      whitelabel: "whitelabel",
    }),
    status_fix() {
      let text = this.status;
      let result = text.replace(/_/gi, " ");
      let parts = result.split(" ");
      let parts_slice = parts.slice(1);
      let capitalize = parts_slice.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      let join = capitalize.join(" ");
      return `${join}`;
    },
    status_css() {
      let text = this.status;
      let result = text.replace("_", "");
      let cls_css = result.replace(/^.{2}/g, "");
      return `${cls_css}`;
    },
  },
  methods: {
    ...mapActions(moduleName, { getDetail: `${moduleName}/getDetail` }),
    async init() {
      await this.getDetail();
    },
    handleButtonClick() {
      this.$router.push({
        name: "WhitelabelDetailPembayaranCicilan",
        params: { idcicilan: this.idCicilan },
      });
    },
  },
};
</script>

<style scoped>
.history-card {
  display: inline-flex;
  gap: 10px;
}

.tombol {
  padding: 0px 20px;
  height: 30px;
  font-size: smaller;
}
.label {
  background-color: #fff8e1;
  padding: 0px 4px 0px 4px;
  width: fit-content;
  border-radius: 3px;
}
.history-card .card-bodyinf {
  background-color: white;
  padding-right: 10px;
  text-align: start;
}

.lunas {
  background-color: #e8fcee;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}

.pembayaran_expired {
  background-color: #da1e28;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
}
</style>
